/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    if (this.container) {
      this.setupEventListeners();
    }
    if (this.container) {
      this.setupEventListeners();
    }
  }
  
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    if (!this.container) return;
    
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    if (this.container) {
      this.container.addEventListener('change', this.debouncedOnChange.bind(this));
    }
  }
  getSectionsToRender() {
    return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.drawer-cart'
      }
    ];
  }
  getSectionInnerHTML(html, selector) {
    // Defensive: if html is missing or selector not found, return empty string
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }
  updateQuantity(line, quantity) {
    if (!this.container) return;
    this.container.classList.add('cart-disabled');

    // Normalize line and quantity to numbers for the API BEFORE touching DOM
    const lineNum = (line !== undefined && line !== null) ? parseInt(line, 10) : null;
    const qtyNum = (quantity !== undefined && quantity !== null) ? (typeof quantity === 'string' ? parseInt(quantity, 10) : quantity) : null;

    // Add a loading class to the matching cart row if present (main cart or drawer)
    if (!isNaN(lineNum) && lineNum > 0) {
      const mainRow = this.container ? this.container.querySelector(`#CartItem-${lineNum}`) : null;
      if (mainRow && mainRow.classList) mainRow.classList.add('loading');
      else {
        const drawer = document.querySelector('#Cart-Drawer');
        const drawerRow = drawer ? drawer.querySelector(`#CartDrawerItem-${lineNum}`) : null;
        if (drawerRow && drawerRow.classList) drawerRow.classList.add('loading');
      }
    }

    const payload = {
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    if (!isNaN(lineNum) && lineNum > 0) payload.line = lineNum;
    if (qtyNum !== null && !isNaN(qtyNum)) payload.quantity = qtyNum;

    const body = JSON.stringify(payload);

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, line);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      })
      .catch((error) => {
        console.error('Cart update error:', error);
        this.displayErrors(line, 'Unable to update cart. Please try again.');
        this.container.classList.remove('cart-disabled');
      });
  }

  displayErrors(line, errors) {
    // Remove loading state from the cart item
    const lineNum = parseInt(line, 10);
    if (!isNaN(lineNum) && lineNum > 0) {
      const mainRow = this.container ? this.container.querySelector(`#CartItem-${lineNum}`) : null;
      if (mainRow) mainRow.classList.remove('loading');
      
      const drawer = document.querySelector('#Cart-Drawer');
      const drawerRow = drawer ? drawer.querySelector(`#CartDrawerItem-${lineNum}`) : null;
      if (drawerRow) drawerRow.classList.remove('loading');
    }

    // Display error message to user
    const errorMessage = typeof errors === 'string' ? errors : JSON.stringify(errors);
    
    // Create or update an error notification
    const existingError = document.querySelector('.cart-error-message');
    if (existingError) {
      existingError.remove();
    }

    const errorDiv = document.createElement('div');
    errorDiv.className = 'cart-error-message';
    errorDiv.style.cssText = 'background-color: #fee; border: 1px solid #f88; color: #c00; padding: 1em; margin: 1em 0; border-radius: 4px;';
    errorDiv.textContent = errorMessage;

    // Insert error message at the top of the cart
    const cartForm = document.querySelector('.thb-cart-form');
    if (cartForm) {
      cartForm.insertBefore(errorDiv, cartForm.firstChild);
      
      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        errorDiv.style.transition = 'opacity 0.3s';
        errorDiv.style.opacity = '0';
        setTimeout(() => errorDiv.remove(), 300);
      }, 5000);
    }
  }

  refresh() {
    if (!this.container) return;
    
    if (!this.container) return;
    
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
        
        dispatchCustomEvent('line-item:change:end', {
          cart: parsedState
        });
      });
  }
  async removeItem(lineIndex) {
    if (!lineIndex) return;

    const cartItem = this.getCartItemElement(lineIndex);
    if (!cartItem) return;

    // Check for badge linking
    const badgeId = this.getBadgeIdFromItem(cartItem);
    // console.log('Found badge ID:', badgeId);

    if (badgeId) {
      // Find all matching keys for this badge id and remove them together
      const keys = await this.findKeysByBadgeId(badgeId);
      // console.log('Badge keys to remove:', keys);
      if (keys && keys.length) {
        try {
          await this.removeItemsByKeysSingleCall(keys);
          return;
        } catch (err) {
          // fall through to per-line removal if bulk fails
        }
      }
    }

    // Default: try to remove the single line using the data-key
    try {
      await this.removeLineItem(lineIndex);
    } catch (err) {
      // Fallback: use quantity update if targeted removal fails
      this.updateQuantity(lineIndex, '0');
    }
  }

  getCartItemElement(lineIndex) {
    // Try to find cart item in main cart or cart drawer
    let cartItem = null;

    if (this.container) {
      // Main cart
      cartItem = this.container.querySelector(`#CartItem-${lineIndex}`);
      
    }

    if (!cartItem) {
      // Cart drawer
      const cartDrawer = document.querySelector('#Cart-Drawer');
      if (cartDrawer) {
        cartItem = cartDrawer.querySelector(`#CartDrawerItem-${lineIndex}`);
        
      }
    }

    return cartItem;
  }
  
  getCartItemVariantId(cartItem) {
    // Get variant ID from cart item's data attributes or hidden inputs
    if (cartItem.dataset.variantId) {
      return cartItem.dataset.variantId;
    }

    const variantInput = cartItem.querySelector('input[name*="[id]"], input[data-variant-id]');
    if (variantInput && (variantInput.value || variantInput.dataset.variantId)) {
      return variantInput.value || variantInput.dataset.variantId;
    }

    // Fallback: attempt to extract variant ID from data-product-id (format: "variantId:hash")
    const productId = cartItem.dataset.productId;
    if (productId) {
      if (productId.includes(':')) {
        return productId.split(':')[0];
      }
      return productId;
    }

    return null;
  }
  
  getCartItemProductId(cartItem) {
    // In Shopify, we don't have direct access to product ID from cart items
    // The data-product-id format is "variantId:hash", not "productId:variantId"
    // We'll need to use other methods to determine the actual product ID
    
    // Try to extract from the product link href
    const productLink = cartItem.querySelector('.cart-product-link, a[href*="/products/"]');
    if (productLink && productLink.href) {
      const urlMatch = productLink.href.match(/\/products\/([^?]*)/);
      if (urlMatch) {
        return urlMatch[1]; // Return product handle, not ID
      }
    }
    
    return null;
  }
  
  // Badge linking methods
  async findKeysByBadgeId(badgeId) {
    if (!badgeId) return [];
    const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
    if (!cartResponse.ok) return [];
    const cart = await cartResponse.json();
    const keys = [];
    for (let i = 0; i < cart.items.length; i++) {
      const apiItem = cart.items[i];
      if (!apiItem) continue;
      const props = apiItem.properties || {};
      const itemBadgeId = (props._BadgeId || props.BadgeId || null);
      if (!itemBadgeId) continue;
      if (itemBadgeId.toString() === badgeId.toString() && apiItem.key) {
        keys.push(apiItem.key);
      }
    }
    return keys;
  }
  
  getBadgeIdFromItem(cartItem) {
    // Prefer an explicit data attribute set in Liquid (`data-badge-id`)
    if (!cartItem) return null;
    if (cartItem.dataset && cartItem.dataset.badgeId && cartItem.dataset.badgeId.trim()) {
      return cartItem.dataset.badgeId;
    }

    // Extract BadgeId from cart item properties (legacy fallback)
    const badgeIdData = cartItem.querySelector('[data-property="_BadgeId"], [data-property="BadgeId"]');

    const propertyElements = cartItem.querySelectorAll('.product-cart-item-options, .line-item-property');
    for (const element of propertyElements) {
      const text = element.textContent || element.innerText;
      // Look for "_BadgeId: [value]"
      const match = text.match(/_?BadgeId:\s*(\S+)/i);
      if (match) {
        return match[1];
      }
    }

    // Check data attributes rendered inline (legacy)
    if (badgeIdData && badgeIdData.dataset && badgeIdData.dataset.value) {
      return badgeIdData.dataset.value;
    }
    return null;
  }
  
  // Helper: fetch cart and find API item for a DOM cart item element
  async getApiItemForDomElement(domItem) {
    if (!domItem || !domItem.dataset || !domItem.dataset.key) return null;
    const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
    if (!cartResponse.ok) throw new Error(`Failed to get cart: ${cartResponse.status}`);
    const cart = await cartResponse.json();
    for (let i = 0; i < cart.items.length; i++) {
      const apiItem = cart.items[i];
      if (apiItem.key === domItem.dataset.key) {
        return { apiItem, line: i + 1 };
      }
    }
    return null;
  }

  // Lightweight cart-change lock to serialize multi-step removals and avoid race conditions
  async acquireCartLock() {
    // simple spin-wait with short sleep; should be sufficient for UI interactions
    if (!this._cartChangeInProgress) {
      this._cartChangeInProgress = true;
      return;
    }
    while (this._cartChangeInProgress) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((r) => setTimeout(r, 40));
    }
    this._cartChangeInProgress = true;
  }

  releaseCartLock() {
    this._cartChangeInProgress = false;
  }

  // Helper: update an item by its key (id) instead of using a line index
  // body supports: id (variant_id or key), quantity, properties
  async updateItemByKey(id, quantity, properties) {
    if (!id) throw new Error('Missing id for updateItemByKey');

    const payload = {
      id,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    if (quantity !== undefined && quantity !== null) payload.quantity = (typeof quantity === 'string' ? parseInt(quantity, 10) : quantity);
    if (properties !== undefined && properties !== null) payload.properties = properties;

    const response = await fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Cart change failed: ${response.status} - ${errText}`);
    }

    return await response.json();
  }

  // Remove multiple items in a single request by their cart `key` values.
  // This uses the cart update endpoint which accepts an `updates` map keyed by
  // 1-indexed line numbers. We fetch the current cart, map each key -> line,
  // build an updates object setting each line to 0, and POST once.
  async removeItemsByKeysSingleCall(keys) {
    // Replace the bulk /cart/update.js approach with reliable per-key removals
    // using the cart_change endpoint for each `data-key`. This avoids race
    // conditions where change.js calls may already have mutated line indices.
    if (!keys || !keys.length) return null;

    await this.acquireCartLock();
    const succeeded = [];
    let lastResult = null;

    try {
      for (const k of keys) {
        try {
          // removed debug log: removing key via change API
          // updateItemByKey posts to cart_change_url and returns parsed JSON
          lastResult = await this.updateItemByKey(k, 0);
          succeeded.push(k);
        } catch (err) {
          // per-key removal failed for key (suppressed)
        }
      }

      if (succeeded.length === 0) {
        throw new Error('All per-key removals failed');
      }

      // After removing items, refresh/render the cart UI once using the
      // last successful response if available, otherwise call refresh().
      try {
        if (lastResult) {
          this.renderContents(lastResult, false, true);
        } else {
          this.refresh();
        }
      } catch (e) {
        // Best-effort fallback
        this.refresh();
      }

      return { success: true, removed: succeeded };
    } finally {
      this.releaseCartLock();
    }
  }

  async removeLineItem(lineIndex) {
    // Remove a line item using the item `key` (id) instead of relying on line index
    const cartItemElement = this.getCartItemElement(lineIndex);
    if (!cartItemElement) {
      throw new Error(`Cart item element not found for index: ${lineIndex}`);
    }

    const itemKey = cartItemElement.dataset.key;
    if (!itemKey) {
      throw new Error('data-key missing on cart row; cannot remove item by key');
    }

    const result = await this.updateItemByKey(itemKey, 0);

    // Refresh cart UI after removal
    if (this.container) {
      this.refresh();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    return result;
  }
  
  removeProductEvent() {
    // Bind remove handlers for main cart container and cart drawer
    const bindRemovesFor = (containerEl) => {
      if (!containerEl) return;
      const removes = containerEl.querySelectorAll('.remove');
      removes.forEach((remove) => {
        // Avoid binding the same listener multiple times
        if (remove.dataset && remove.dataset.cartRemoveBound === '1') return;
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          const index = event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.index ? event.currentTarget.dataset.index : (event.target.closest && event.target.closest('[data-index]') ? event.target.closest('[data-index]').dataset.index : null);
          this.removeItem(index);
        });
        if (remove.dataset) remove.dataset.cartRemoveBound = '1';
      });
    };

    // Main cart
    bindRemovesFor(this.container);

    // Cart drawer (may exist outside this.container)
    const cartDrawer = document.querySelector('#Cart-Drawer');
    bindRemovesFor(cartDrawer);
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return; // Skip if section doesn't exist on this page

      const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;

      // Preserve details element open states before DOM replacement
      const detailsStates = new Map();
      const allDetails = elementToReplace.querySelectorAll('details');
      allDetails.forEach((details, index) => {
        detailsStates.set(index, details.open);
      });

      // Decide where to read HTML from depending on refresh or change flow
      let htmlToInsert = '';
      if (refresh) {
        if (parsedState && parsedState[section.section]) {
          htmlToInsert = parsedState[section.section];
        }
      } else {
        const sectionsObj = parsedState && (parsedState.sections || parsedState);
        if (sectionsObj && sectionsObj[section.section]) {
          htmlToInsert = sectionsObj[section.section];
        }
      }

      if (htmlToInsert) {
        const inner = this.getSectionInnerHTML(htmlToInsert, section.selector);
        if (inner !== null && inner !== undefined && inner.trim().length) {
          elementToReplace.innerHTML = inner;
          
          // Restore details element open states after DOM replacement
          const newDetails = elementToReplace.querySelectorAll('details');
          newDetails.forEach((details, index) => {
            if (detailsStates.has(index)) {
              details.open = detailsStates.get(index);
            }
          });
          
          this.removeProductEvent();
          if (line && this.container && this.container.querySelector(`#CartItem-${line}`)) {
            this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
          }
          return; // next section
        }
      }

      // Fallback: try scanning all returned HTML fragments in parsedState to find one
      // that contains our selector. This handles responses where the section key differs.
      const tryFindHtml = (obj) => {
        if (!obj) return null;
        for (const key of Object.keys(obj)) {
          try {
            const candidate = obj[key];
            // First try by selector
            const innerBySelector = this.getSectionInnerHTML(candidate, section.selector);
            if (innerBySelector) return innerBySelector;

            // Then try to find the fragment by the section id (e.g., #Cart-Drawer)
            try {
              const doc = new DOMParser().parseFromString(candidate, 'text/html');
              const byId = doc.getElementById(section.id);
              if (byId && byId.innerHTML) return byId.innerHTML;

              // Lastly, try matching by tag name of the target container (if present)
              const targetEl = document.getElementById(section.id);
              if (targetEl) {
                const tag = targetEl.tagName && targetEl.tagName.toLowerCase();
                if (tag) {
                  const byTag = doc.querySelector(tag);
                  if (byTag && byTag.innerHTML) return byTag.innerHTML;
                }
              }
            } catch (innerErr) {
              // ignore parse errors and continue
            }
          } catch (e) {
            // ignore parse errors and continue
          }
        }
        return null;
      };

      let fallbackInner = null;
      if (parsedState) {
        // Try scanning fragments and debug which key matched
        const scanSrc = parsedState.sections || parsedState;
        fallbackInner = tryFindHtml(scanSrc) || tryFindHtml(parsedState);
        // no-op: fallbackInner used below
        
      }

      if (fallbackInner) {
        elementToReplace.innerHTML = fallbackInner;
        
        // Restore details element open states after fallback DOM replacement
        const newDetails = elementToReplace.querySelectorAll('details');
        newDetails.forEach((details, index) => {
          if (detailsStates.has(index)) {
            details.open = detailsStates.get(index);
          }
        });
      }

      this.removeProductEvent();
      if (line && this.container && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
    });
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});

// Delivery Estimate functionality
let cachedBankHolidays = null;

async function refreshDeliveryEstimates() {
  const estimateEls = document.querySelectorAll(".delivery-estimate");
  if (!estimateEls.length) return;

  // Try to pull cached holidays from sessionStorage
  let bankHolidays = cachedBankHolidays;
  const cacheKey = "uk_bank_holidays";
  
  if (!bankHolidays) {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try {
        bankHolidays = JSON.parse(cached).map(date => new Date(date));
        cachedBankHolidays = bankHolidays;
      } catch {
        sessionStorage.removeItem(cacheKey);
      }
    }
  }

  // If no cache, fetch fresh holidays
  if (!bankHolidays) {
    try {
      const res = await fetch("https://www.gov.uk/bank-holidays.json");
      const data = await res.json();

      const englandWales = data["england-and-wales"].events.map(e => e.date);
      const scotland = data["scotland"].events.map(e => e.date);
      const uniqueDates = [...new Set([...englandWales, ...scotland])];

      bankHolidays = uniqueDates.map(date => new Date(date));
      cachedBankHolidays = bankHolidays;

      // Cache for this session
      sessionStorage.setItem(cacheKey, JSON.stringify(uniqueDates));
      } catch (err) {
        bankHolidays = [];
      }
  }

  const isBankHoliday = (date) =>
    bankHolidays.some(holiday => holiday.toDateString() === date.toDateString());

  const isWorkingDay = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6 && !isBankHoliday(date);
  };

  const addWorkingDays = (startDate, days) => {
    const date = new Date(startDate);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date)) {
        added++;
      }
    }

    // If final date falls on weekend or holiday, bump forward
    while (!isWorkingDay(date)) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  };

  estimateEls.forEach(el => {
    const daysToAdd = parseInt(el.dataset.days, 10);
    if (!daysToAdd || isNaN(daysToAdd) || daysToAdd <= 0) {
      el.style.display = "none";
      return;
    }

    const today = new Date();
    const estimatedDate = addWorkingDays(today, daysToAdd);
    const formatted = estimatedDate.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    });

    el.textContent = `Estimated delivery: ${formatted}`;
    el.style.display = "inline";
  });
}

// Initialize delivery estimates and set up event listeners on DOM load
document.addEventListener("DOMContentLoaded", () => {
  
  // Initial load of delivery estimates
  refreshDeliveryEstimates();

  // Test if we can add event listeners
  try {
    // Refresh delivery estimates when cart drawer opens
    document.addEventListener("cart-drawer:open", (e) => {
      setTimeout(refreshDeliveryEstimates, 100);
    });

    // Also listen for when cart is refreshed (when items are added/updated)
    document.addEventListener("cart:refresh", (e) => {
      setTimeout(refreshDeliveryEstimates, 100);
    });    
  } catch (error) {
  }

  // Watch for cart drawer opening via body class change
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (document.body.classList.contains('open-cc')) {
          setTimeout(refreshDeliveryEstimates, 100);
        }
      }
    });
  });

  observer.observe(document.body, { 
    attributes: true, 
    attributeFilter: ['class'] 
  });
});